import { Component, Host, h, Prop, Event, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-radio-button',
  styleUrl: 'cobalt-radio-button.css'
})
export class CobaltRadioButton {
  /**
   * The label that accompany the radio button. It is **required** for accessibility concerns.
   */
  @Prop({ mutable: true, reflect: true }) label!: string
  /**
   * Description will append below the label.
   */
  @Prop({ mutable: true }) description?: string
  /**
   * A string indicating the position of the label or if it is hidden.
   */
  @Prop({ mutable: true }) format?: 'right' | 'left' | 'hidden' = 'right'
  /**
   * A Boolean indicating whether the radio is checked or unchecked.
   */
  @Prop({ mutable: true, reflect: true }) checked?: boolean = false
  /**
   * A boolean indicating the disable state of the radio button. The `aria-disabled` attribute relies on this property.
   */
  @Prop({ mutable: true, reflect: true }) disabled?: boolean = false

  /**
   * Emitted when the checked value has changed.
   */
  @Event() cobaltRadioButtonChange: EventEmitter

  handleCheck = (): void => {
    if (this.disabled) return
    this.checked = !this.checked
    this.cobaltRadioButtonChange.emit(this.checked)
  }

  render(): any {
    return (
      <Host>
        <core-radio-button
          label={this.label}
          description={this.description}
          format={this.format}
          checked={this.checked}
          disabled={this.disabled}
          onCoreRadioButtonChange={this.handleCheck}
        ></core-radio-button>
      </Host>
    )
  }
}
